module.exports = __webpack_public_path__ + "fd64c4f542331b6b7de92d30ceff75f0.pdf";